import React from 'react';
import typeUtils from '@legacy/helpers/utils/typeUtils.js.es6';

const ErrorNotif = (props) => {
    const { show, className, message } = props;
    const classNames = [
        'bl-new-booklist-form__error-container',
        'row'
    ];

    if(!typeUtils.isEmptyString(className)) {
        classNames.push(className);
    }

    if(!show){
        classNames.push('hidden');
    }

    return (
        <div className={classNames.join(' ')}>
            <div className="col-md-12 text-center alert alert-danger">
                { message || '' }
            </div>
        </div>
    );
};

BOOKLIST.components.ErrorNotif = ErrorNotif;

export default ErrorNotif;